import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './utils/colorThemeInitializer'
import { setupDynamicRobots } from './utils/robotsHandler'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Setup dynamic robots protection after React has mounted
setupDynamicRobots()
